/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { Route, Switch, withRouter } from 'react-router'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';

import { AppFrameNoSideNav } from './AppFrame';

import LoginEmail from 'components/pages/login/LoginEmail'
import LoginPassword from 'components/pages/login/LoginPassword'
import LoginMfa from 'components/pages/login/LoginMfa'
import AcceptInvitation from 'components/pages/login/AcceptInvitation'
import MissingInvitation from 'components/pages/login/MissingInvitation'
import Token from 'components/pages/token'
import ForgotPassword from 'components/pages/other/ForgotPassword'
import GroupSetup from 'components/pages/GroupSetup'
import GoodbyeGroup from 'components/pages/profile/GoodbyeGroup';
import GroupDeleted from 'components/pages/GroupDeleted';
import NotFoundError from 'components/pages/common/NotFoundError';

import AppUtils from 'lib/AppUtils';
import routeNames from 'lib/routeNames';
import CustomerService from 'lib/CustomerService';

import groupSelectors from 'redux/reduxStore/group';
import navigationActions from 'redux/actions/navigation';

function mapStateToProps(state) {
  return {
    isDataFetched: groupSelectors.getIsDataFetched(state),
    isGroupNameValid: groupSelectors.getIsValidGroup(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goLogin: () => {
      dispatch(navigationActions.goTo(routeNames.loginEmail()));
    },
  };
}

class UnauthorizedRoutes extends React.Component {

  UNSAFE_componentWillMount() {
    CustomerService.shutdown();
    CustomerService.initAnonymous();
  }

  render() {
    const hasGroupName = !!AppUtils.getGroupSubdomain();
    const { isGroupNameValid, isDataFetched } = this.props;

    if (hasGroupName && !isDataFetched) {
      return null;
    } else if (hasGroupName && !isGroupNameValid) {
      return (
        <AppFrameNoSideNav
          onClickLogo={null}
          isSidebarOpen={false}
        >
          <Route path="/" component={NotFoundError} />
        </AppFrameNoSideNav>
      );
    } else if (hasGroupName && isGroupNameValid) {
      return (
        <AppFrameNoSideNav
          onClickLogo={this.props.goLogin}
          isSidebarOpen={false}
        >
          <Switch>
            <Route path={routeNames.token()} component={Token} />
            <Route path={routeNames.acceptInvitation()} component={AcceptInvitation} />
            <Route path={routeNames.missingInvitation()} component={MissingInvitation} />

            <Route path={routeNames.goodbyeGroup()} component={GoodbyeGroup} />

            <Route exact path={routeNames.forgotPassword()} component={ForgotPassword} />

            <Route path={routeNames.loginMfa()} exact component={LoginMfa} />
            <Route path={routeNames.loginPassword()} exact component={LoginPassword} />
            <Route path={routeNames.loginEmail()} exact component={LoginEmail} />

            <Route path="/" component={LoginEmail} />
          </Switch>
        </AppFrameNoSideNav>
      );
    } else {
      return (
        <AppFrameNoSideNav
          onClickLogo={null}
          isSidebarOpen={false}
        >
          <Switch>
            <Route exact path={routeNames.groupSetup()} component={GroupSetup} />
            <Route exact path={routeNames.groupSetupSuccess()} component={GroupSetup} />
            <Route exact path={routeNames.groupDeleted()} component={GroupDeleted} />

            <Route path="/" component={NotFoundError} />
          </Switch>
        </AppFrameNoSideNav>
      );
    }
  }
}
UnauthorizedRoutes.propTypes = {
  isGroupNameValid: PropTypes.bool,
  isDataFetched: PropTypes.bool,
  goLogin: PropTypes.func,
};

export default hot(module)(withRouter(connect(mapStateToProps, mapDispatchToProps)(UnauthorizedRoutes)));
